import { defineMessages } from "./define.js";

/** Sign-in, the invite-only register screen, and the session's own failures. */
export const auth = defineMessages("auth", {
  /* ------------------------------------------------------------- sign in */
  signInTitle: { ru: "С возвращением", en: "Welcome back" },
  signInLede: {
    ru: "Общее пространство на двоих. Только для тех, кого позвали.",
    en: "A shared space for two. Only for people who were invited.",
  },
  haveInvite: { ru: "Есть код приглашения?", en: "Got an invite code?" },
  registerLink: { ru: "Зарегистрироваться", en: "Create an account" },
  /* Приглашение, которое показали с экрана: системная камера открывает
     ссылку сама, но она не всегда под рукой, а приложение уже открыто. */
  scanInvite: { ru: "Сканировать приглашение", en: "Scan an invitation" },
  signIn: { ru: "Войти", en: "Sign in" },
  signingIn: { ru: "Входим…", en: "Signing in…" },

  /* ------------------------------------------------------------ register */
  registerTitle: { ru: "Приглашение", en: "Invitation" },
  registerLede: {
    ru: "Регистрация только по коду.",
    en: "By invitation code only.",
  },
  haveAccount: { ru: "Уже есть аккаунт?", en: "Already have an account?" },
  acceptInvite: { ru: "Принять приглашение", en: "Accept invitation" },
  registering: { ru: "Создаём…", en: "Creating…" },

  /* -------------------------------------------------------------- fields */
  inviteCode: { ru: "Код приглашения", en: "Invite code" },
  name: { ru: "Имя", en: "Name" },
  nameHint: { ru: "Так вас увидят в пространстве", en: "How you show up in the space" },
  /**
   * Only on screen for a code that opens a space of one's own — a code into
   * somebody else's space lands in a space that already has a name, and asking
   * for one there would promise a rename that never happens.
   */
  spaceName: { ru: "Название вашего пространства", en: "The name of your space" },
  spaceNameHint: {
    ru: "Можно не заполнять — тогда «{name}». Переименовать можно позже.",
    en: "Leave it blank for “{name}”. It can be renamed later.",
  },
  spaceNameInvalid: {
    ru: "От 1 до 120 символов",
    en: "Between 1 and 120 characters",
  },
  email: { ru: "Почта", en: "Email" },
  password: { ru: "Пароль", en: "Password" },
  /* Пароль без сброса по почте — значит опечатку при регистрации выяснит
     только следующий вход, а починит команда на сервере. Одна кнопка это
     снимает. */
  showPassword: { ru: "Показать пароль", en: "Show the password" },
  hidePassword: { ru: "Скрыть пароль", en: "Hide the password" },
  passwordHint: {
    ru: "От 10 символов. Восстановления пароля нет.",
    en: "10 characters or more. There is no password recovery.",
  },

  /* --------------------------------------------------------- what is wrong */
  inviteCodeRequired: { ru: "Код приглашения обязателен", en: "The invite code is required" },
  nameRequired: { ru: "Как вас звать?", en: "What should we call you?" },
  emailInvalid: {
    ru: "Похоже на неверный адрес почты",
    en: "That does not look like an email address",
  },
  passwordRequired: { ru: "Введите пароль", en: "Enter your password" },
  passwordTooShort: {
    ru: "Не короче 10 символов — длина важнее спецсимволов",
    en: "At least 10 characters — length beats punctuation",
  },
  /** The catch-all for a field the screen has no wording of its own for. */
  fieldInvalid: { ru: "Проверьте это поле", en: "Check this field" },

  /* ------------------------------------------------------------- session */
  sessionExpired: { ru: "Сессия истекла. Войдите снова", en: "Your session expired. Sign in again" },
  serverUnreachable: { ru: "Не удалось связаться с сервером", en: "Could not reach the server" },
});
